// extracted by mini-css-extract-plugin
export default {"cta":"ZL-z","disabled":"_L-z"};